import React, {useEffect, useState} from "react";
// import services from "../../Services/SearchResultService";
import rest from "./results.json";
import "./search.css";
import {Link, useHistory, useParams} from "react-router-dom";

const EXTURL = 'https://api.documenu.com/v2/restaurants/search/fields?zip_code=02120&key=eb12d93b695847acfe7f2ec50ca6813f';

const SearchItem = ({hotel}) => {


    const searchTerm = useParams().searchTerm;
    const searchName = useParams().searchName;
    const history = useHistory();
    // history.push(searchTerm,[]);
    const redirect = () => {
        history.push(searchTerm);
        history.push(searchName);
    }

    const id = "/details/" + hotel.restaurant_id;
    return(

            <li style={{width: "270px", float: "left", display: "block"}} className="m-5 wd-item">
                <Link to={id} onClick={redirect}>
                <article className="box">
                    <figure className="wd-rounded"><a href="#" className="hover-effect popup-gallery"><img width="270" height="160" alt=""
                                                                                    src="https://i.picsum.photos/id/365/5616/3744.jpg?hmac=m9Chefr19BelgN9G4ErJVFBbdvNmA_xlbd0CjATLwhM" className="rounded"
                                                                                    draggable="false"/></a></figure>
                </article>
                </Link>
                    {/*<p><i className="fa fa-bookmark"> </i></p>*/}
                    <div className="row m-0 p-0">
                        <div className="col-10 m-0 p-0">
                            <i>
                            <h6 className="box-title m-0 p-0" style={{float:"left"}}>{hotel.restaurant_name}</h6>
                            </i>
                        </div>
                        <div className="col-2 m-0 p-0">
                            <p style={{float:"right"}} className=" m-0 p-0"><b>{hotel.price_range}</b></p>
                        </div>

                    </div>

                    <div className="row m-0 p-0">
                        <p className="col-12 m-0 p-0 wd-line"><small><strong>
                            {hotel.cuisines.join(", ")}
                        </strong>
                        </small>
                        </p>
                    </div>

            </li>



    );
}
export default SearchItem;

// <>
        //     {
//         searchRes.map(hotel =>
//             <>
//                 <div className="col-3 m-3" style={{float:"left"}}>
//                     <div>
//
//                         <div className="wd-border wd-main-image">
//                             <div>
//                                 <img src={hotel.postImage} className="img-fluid wd-main-image" alt = "postImage"/>
//                             </div>
//                             <div className="wd-pad">
//                                 <div className="wd-col-eightyPercent col-9">
//                                     <p id="sub-title">{hotel.name}</p>
//                                     <p>{hotel.cusine}</p>
//                                     <i className="fas fa-map-marker-alt"></i>{hotel.location}
//                                 </div>
//                                 <div className="col-3">
//                                     <p>{hotel.rating}</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </>
//         )
//     }
// </>
